import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Button, Card, CardBody, CardTitle, Spinner } from "reactstrap";
import Form from 'react-bootstrap/Form';

const ConfirmForm = ({ t, onConfirm, onBackButtonClicked, isLoading }) => {
    const [declarationFormConfirmed, setDeclarationFormConfirmed] = useState(false);

    return (
        <div className="declaration-confirm-form m-2 mt-0">
            <Card>
                <CardBody>
                    <CardTitle className="mb-3">
                        {t('Declaration of Accuracy and Completeness')}
                    </CardTitle>

                    <p className="mb-5">
                        {
                            t('I hereby affirm that the information provided in this questionnaire is true, accurate, and complete to the best of my knowledge and belief. I understand that any false statements, omissions, or misrepresentations may result in consequences as determined by the entity requesting this information (which could include legal actions or disqualification from a process, depending on the context). I commit to notify the relevant parties immediately should any information change after the submission of this questionnaire.')
                        }
                    </p>

                    <div>
                        <Form.Check
                            onChange={({ target }) => setDeclarationFormConfirmed(target.checked)}
                            type='checkbox'
                            id={`confirm-declaration-checkbox`}
                            label={t('I confirm the information above.')} />
                    </div>
                </CardBody>
            </Card>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <Button
                    color="secondary"
                    onClick={onBackButtonClicked}
                    type="button"
                >
                    {t('Back')}
                </Button>
                
                <Button color="primary"
                    disabled={!declarationFormConfirmed || isLoading}
                    onClick={onConfirm}
                    type="button">
                    {
                        isLoading ? (
                            <>
                                <Spinner 
                                    className="me-2" 
                                    animation="border" 
                                    size="sm" 
                                />
                                {t('Submitting')}...
                            </>
                        ) : (
                            <>{t('Submit')}</>
                        )
                    }
                </Button>
            </div>
        </div>
    )
}

export default withNamespaces()(
    ConfirmForm
);